import React from 'react';
import { Store, TrendingUp } from 'lucide-react';

function TopSellersTable({ sellers }) {
  if (!sellers || sellers.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-8 text-center">
        <Store className="w-12 h-12 text-slate-300 mx-auto mb-3" />
        <p className="text-slate-500 font-montserrat">No hay datos de vendedores</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-slate-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 font-montserrat">#</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 font-montserrat">Vendedor</th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-slate-600 font-montserrat">Entregas</th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-slate-600 font-montserrat">Éxito</th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-slate-600 font-montserrat">Cobrado</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {sellers.map((seller, index) => (
              <tr key={seller.id} className="hover:bg-slate-50 transition-colors">
                <td className="px-4 py-3 text-sm font-bold text-[#B1336E] font-montserrat">
                  {index + 1}
                </td>
                <td className="px-4 py-3">
                  <div>
                    <p className="text-sm font-semibold text-slate-900 font-montserrat">
                      {seller.username}
                    </p>
                    {seller.email && (
                      <p className="text-xs text-slate-500 font-montserrat">{seller.email}</p>
                    )}
                  </div>
                </td>
                <td className="px-4 py-3 text-right">
                  <span className="text-sm font-semibold text-slate-900 font-montserrat">
                    {seller.total_deliveries}
                  </span>
                </td>
                <td className="px-4 py-3 text-right">
                  <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-bold font-montserrat ${
                    seller.success_rate >= 90 
                      ? 'bg-[#67A43C]/10 text-[#67A43C]'
                      : seller.success_rate >= 70
                      ? 'bg-[#E6B43C]/10 text-[#E6B43C]'
                      : 'bg-red-50 text-red-600'
                  }`}>
                    {seller.success_rate}%
                  </span>
                </td>
                <td className="px-4 py-3 text-right">
                  <span className="text-sm font-bold text-slate-900 font-montserrat">
                    S/ {seller.total_charged.toFixed(2)}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TopSellersTable;